import type { ISamoletConfiguration } from '../types';
import { authApiClient } from './client';

export async function checkSso(config: ISamoletConfiguration): Promise<boolean> {
  try {
    const { data } = await authApiClient.get(config.urls.getJWTUrl(), {
      withCredentials: true,
    });

    return !!data?.id_token;
  } catch (e) {
    return false;
  }
}
